'use client';
import { routes } from '@/lib/routes';
import notFoundImg from '@/public/image/not-found.svg';
import { Box, Button, Flex, Overlay, Text } from '@mantine/core';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

const NotFound = () => {
  const router = useRouter();
  return (
    <Box className="h-screen overflow-hidden">
      <Image src={notFoundImg} alt="" className="h-full w-full object-cover" />
      <Overlay backgroundOpacity={0.1}>
        <Flex className="relative z-50 mt-[203px] h-full flex-col items-center text-center">
          <Text className="text-[28px] font-semibold leading-[30px] text-gray-800">
            Page Not Found
          </Text>
          <Text className="mb-4 text-[14px] font-[350] leading-5 text-gray-600">
            Uh oh, we can&lsquo;t seem to find the page you&lsquo;re looking
            for.
            <Text inherit span className="block">
              Try going back to the previous page
            </Text>
          </Text>
          <Button
            onClick={() => router.push(routes.app.dashoard)}
            className="!text-palegreen"
          >
            Go To Dashboard
          </Button>
        </Flex>
      </Overlay>
    </Box>
  );
};

export default NotFound;
